import Entity from "./Entity";

const InvoiceSalesPerson = ({
  salesUser = false,
  invoiceSalesPersonType = false,
} = {}) => `
  id
  ${
    salesUser
      ? `salesUser {
      ${Entity}
    }`
      : ""
  }
  salesUserId
  typeId
  ${
    invoiceSalesPersonType
      ? `invoiceSalesPersonType {
    id
    name
  }`
      : ""
  }
  split
  timestamp
`;

export default InvoiceSalesPerson;
